import * as React from "react";
const SvgFiRrHourglass = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M17 24H7.005a4.02 4.02 0 0 1-3.045-1.4 3.95 3.95 0 0 1-.916-3.158A12.52 12.52 0 0 1 7.445 12a12.52 12.52 0 0 1-4.4-7.444A3.95 3.95 0 0 1 3.96 1.4 4.02 4.02 0 0 1 7.005 0H17a4.02 4.02 0 0 1 3.847 2.877c.159.545.198 1.117.115 1.678A12.56 12.56 0 0 1 16.552 12a12.56 12.56 0 0 1 4.405 7.448 3.95 3.95 0 0 1-.918 3.156A4.02 4.02 0 0 1 17 24m0-22H7.005a2.01 2.01 0 0 0-1.928 1.428 1.9 1.9 0 0 0-.055.828c.375 2.5 1.922 4.84 4.6 6.957a1 1 0 0 1 0 1.568c-2.678 2.119-4.222 4.461-4.6 6.96a1.92 1.92 0 0 0 .455 1.559 2.01 2.01 0 0 0 1.528.7H17a2.015 2.015 0 0 0 1.928-1.427c.079-.268.098-.55.056-.827-.373-2.487-1.92-4.829-4.6-6.962a1 1 0 0 1 0-1.564c2.681-2.133 4.228-4.475 4.6-6.963a1.92 1.92 0 0 0-.46-1.557A2.01 2.01 0 0 0 17 2"
    />
  </svg>
);
export default SvgFiRrHourglass;
